// Styling
import style from "./header--search-dropdown.module.scss";

export default function SearchDropdown({ searchState }) {
  // -- Use State
  // - Search Dropdown State
  const searchDropdownState = searchState ? "open" : "closed";

  // TODO: Add aria-expanded to search input

  if (!searchState) {
    return;
  }

  return (
    <div
      className={`${style.searchDropdownWrapper}`}
      state={searchDropdownState}
    >
      Search Dropdown
    </div>
  );
}
